import { createFeatureSelector, MemoizedSelector, createSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import { IRouterUrlState } from '@nha/state';
import { Params } from '@angular/router';

export const getRouterState = createFeatureSelector<fromRouter.RouterReducerState<IRouterUrlState>>('router');

export const getRouterStateUrl = createSelector(getRouterState, (routerState: fromRouter.RouterReducerState<IRouterUrlState>) => {
	return routerState ? routerState.state : null;
});

export const getRouteUrl = createSelector(getRouterStateUrl, (routerStateUrl: IRouterUrlState) => {
	return routerStateUrl && routerStateUrl.url;
});

export const getRouteParams = createSelector(getRouterStateUrl, (routerStateUrl: IRouterUrlState) => {
	return routerStateUrl ? routerStateUrl.params : {};
});

export const getRouteParam = (param: string): MemoizedSelector<object, string> => {
	return createSelector(getRouteParams, (params: Params) => {
		return params[param];
	});
};

export const getRouteQueryParams = createSelector(getRouterStateUrl, (routerStateUrl: IRouterUrlState) => {
	return routerStateUrl ? routerStateUrl.queryParams : {};
});

export const getRouteData = createSelector(getRouterStateUrl, (routerStateUrl: IRouterUrlState) => {
	return routerStateUrl.data;
});
